import { useState, useCallback } from 'react'
import { betkoPopupWithAction } from '../utils/BetkoPopupModal'
import SingleCommentContentPopup from '../components/Redesign/SingleComment/SingleCommentContentPopup'
import axios from '../config/axios'

const useCommentPopup = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchAndShowPopup = useCallback(async (calculatorType) => {
    setLoading(true)
    setError(null)

    try {
      const helpItemRes = await axios.get(
        `/helpitem-url-from-title/${calculatorType}`
      )
      const helpItemUrl = helpItemRes.data?.url

      if (!helpItemUrl) {
        throw new Error('No URL found for calculator type')
      }

      const url = new URL(helpItemUrl)
      const commentId = url.searchParams.get('commentId')

      if (!commentId) {
        throw new Error('No commentId found in URL')
      }

      const commentRes = await axios.get(`/getComment/${commentId}`)
      const commentData = commentRes.data

      betkoPopupWithAction(
        null,
        '',
        () => (
          <SingleCommentContentPopup
            item={commentData.data}
            url={helpItemUrl}
          />
        ),
        {
          hasBorder: true,
          isContentCentered: true,
        }
      )
    } catch (err) {
      console.error('Error loading tutorial comment:', err)
      setError(err)
      betkoPopupWithAction(
        'Tutorijal u izradi',
        `Tutorijal ${calculatorType} će uskoro biti dostupan.`
      )
    } finally {
      setLoading(false)
    }
  }, [])

  return { fetchAndShowPopup, loading, error }
}

export default useCommentPopup
